/**
 * recordsCache.js — Module-level cache for fulfillment records
 *
 * Lives outside React's component lifecycle so it survives navigation.
 * Both FulfillmentTracker and FulfillmentDashboard read from and write
 * to this cache, so switching between pages renders immediately from
 * cache while a background fetch runs.
 *
 * TTL is 5 minutes — records only update once a day via S3 ingest.
 * Real-time status/notes changes are written back to cache immediately
 * after each PATCH so the dashboard stays current during packing parties.
 */

const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

let _records     = [];
let _lastFetched = null;

/** Returns cached records if still fresh, otherwise null. */
export function getCachedRecords() {
  if (_lastFetched && Date.now() - _lastFetched < CACHE_TTL_MS) {
    return _records;
  }
  return null;
}

/** Writes records to cache and stamps the fetch time. */
export function setCachedRecords(records) {
  _records     = records;
  _lastFetched = Date.now();
}

/** Forces cache to expire on next read (e.g. after a fresh upload). */
export function invalidateCache() {
  _lastFetched = null;
}